<template>
	<div class="table-paging">
		<label class="total">{{ labelText }} {{ total }} </label>
		<el-pagination v-if="isPaginationNecessary" v-bind="{total, pageSize, currentPage, layout, ...$attrs}" data-cy="pagination"
			@update:currentPage="updateCurrentPage" @current-change="$emit('current-change', $event)" />
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsPaging',

	props: {
		layout: { type: String, default: 'prev, pager, next' },
		label: String,
		labelKey: { type: String, default: 'frmViewPocetRad' },
		currentPage: { type: Number },
		total: { type: Number, required: true },
		pageSize: { type: Number, required: true },
		isPaginationNecessary: { type: Boolean, default: true },
	},

	computed: {
		labelText() {
			return this.label || this.LocalizePopisostatni(this.labelKey);
		},
	},

	methods: {
		updateCurrentPage(event) {
			this.$emit('update:currentPage', event);
		},
	},
});
</script>
